import * as React from 'react';

// tslint:disable-next-line:no-empty-interface
export interface IDistributorSaleProps {
}

// tslint:disable-next-line:no-empty-interface
export interface IDistributorSaleState {
}

export class DistributorSale extends React.Component<IDistributorSaleProps, IDistributorSaleState> {
  constructor(props: IDistributorSaleProps) {
    super(props);

        this.state = {
    }
  }

  public render() {
    return (
      <div>
          DistributorSale
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/distributor/sale/DistributorSale.tsx